import { httpResource } from '@angular/common/http';
import { Component, signal } from '@angular/core';

import type { MenuLI } from '../../../types/menu-li';
import type { Temperature } from '../../../types/temperature';

import { Environment } from '../../../../environments/environment';
import { Desktop } from './desktop/desktop';
import { Mobile } from './mobile/mobile';

@Component({
  imports: [Desktop, Mobile],
  selector: 'app-the-villages',
  templateUrl: './the-villages.html',
})
export class TheVillages {
  protected readonly menuItems = signal<MenuLI[]>([
    {
      label: 'Learn About Us',
      showOnDesktop: true,
      submenuItems: [
        { label: 'About Us', url: '/about/' },
        { label: "What's New", showOnDesktop: true, url: '/whats-new/' },
        { label: 'Our Location', showOnDesktop: true, url: '/about-us/location/' },
        {
          label: 'Community Districts',
          showOnDesktop: true,
          url: '/about-us/community-districts/',
        },
        { label: 'Affordability', showOnDesktop: true, url: '/cost-of-living/' },
        { label: 'FAQs', showOnDesktop: true, url: '/about-us/faq/' },
      ],
      type: 'about',
      url: '/about/',
    },
    {
      label: 'Lifestyle',
      showOnDesktop: true,
      submenuItems: [
        {
          color: 'hover:bg-accent-7-500',
          label: 'Seasons of Celebration',
          showOnDesktop: true,
          url: '/seasons-of-celebration/',
        },
        { label: 'Overview', url: '/lifestyle/' },
        { color: 'hover:bg-accent-1-500', label: 'Golf', showOnDesktop: true, url: '/golf/' },
        {
          color: 'hover:bg-accent-2-500',
          label: 'Recreation',
          showOnDesktop: true,
          url: '/recreation/',
        },
        {
          color: 'hover:bg-accent-3-500',
          label: 'Trails & Parks',
          showOnDesktop: true,
          url: '/trails-parks/',
        },
        {
          color: 'hover:bg-accent-4-500',
          label: 'Entertainment',
          showOnDesktop: true,
          url: '/entertainment/',
        },
        {
          color: 'hover:bg-accent-5-500',
          label: 'Shopping & Dining',
          showOnDesktop: true,
          url: '/shopping-dining/',
        },
        {
          color: 'hover:bg-accent-6-500',
          label: 'Health & Wellness',
          showOnDesktop: true,
          url: '/health-wellness/',
        },
      ],
      type: 'lifestyle',
      url: '/lifestyle/',
    },
    {
      label: 'Homes',
      showOnDesktop: true,
      submenuItems: [
        { label: 'Our Homes', url: '/homes/' },
        { label: 'Search Homes', showOnDesktop: true, url: '/homefinder/' },
        { label: 'Become a Villager', showOnDesktop: true, url: '/become-a-villager/' },
        { label: 'Home Series', showOnDesktop: true, url: '/home-series/' },
        { label: 'New Neighborhoods', showOnDesktop: true, url: '/homes/new-neighborhoods/' },
        { label: 'Cost of Living', showOnDesktop: true, url: '/cost-of-living/' },
        { label: 'Resources', showOnDesktop: true, url: '/home-resources/' },
      ],
      type: 'homes',
      url: '/homes/',
    },
    {
      label: 'Visit',
      showOnDesktop: true,
      submenuItems: [
        { label: 'Visit The Villages', url: '/visit/' },
        { label: 'Request Free Information', showOnDesktop: true, url: '/freetour/' },
        { label: 'Plan a Lifestyle Stay', showOnDesktop: true, url: '/lifestyle-preview-plan/' },
        { label: 'Directions', showOnDesktop: true, url: '/directions/' },
        { label: 'Community Map', showOnDesktop: true, url: '/map/' },
      ],
      type: 'visit',
      url: '/visit/',
    },
    {
      label: 'Calendar',
      showOnDesktop: true,
      submenuItems: [
        {
          color: 'hover:bg-accent-7-500',
          label: 'Seasons of Celebration',
          showOnDesktop: true,
          url: '/seasons-of-celebration/',
        },
        { label: 'Events', url: '/calendar/' },
        { label: 'Special Events', showOnDesktop: true, url: '/special-events/' },
        { label: 'Free Daily Entertainment', showOnDesktop: true, url: '/free-entertainment/' },
        { label: 'Ticketed Entertainment', showOnDesktop: true, url: '/ticketed-entertainment/' },
      ],
      type: 'calendar',
      url: '/calendar/',
    },
    {
      label: 'Careers',
      showOnDesktop: true,
      submenuItems: [
        { label: 'Overview', url: '/careers/' },
        { label: 'Our Industries', showOnDesktop: true, url: '/careers/our-industries/' },
        { label: 'Culture', showOnDesktop: true, url: '/careers/culture/' },
        { label: 'Benefits', showOnDesktop: true, url: '/careers/benefits/' },
        { label: 'Live Work Play', showOnDesktop: true, url: '/careers/live-work-play/' },
        { label: 'Charter School', showOnDesktop: true, url: '/careers/charter-school/' },
        { label: 'Getting Here', showOnDesktop: true, url: '/careers/getting-here/' },
        { label: 'Search Jobs', showOnDesktop: true, url: '/careers/search/' },
      ],
      type: 'careers',
      url: '/careers/',
    },
    {
      label: 'More',
      submenuItems: [
        { label: 'FAQ', url: '/faq/' },
        { label: 'Middleton by The Villages', url: 'https://mymiddleton.com/' },
        { label: 'Meet Our Team', url: '/sales-reps/' },
        { label: 'Feedback', url: '/feedback/' },
        { label: 'Contact Us', url: '/contact-us/' },
      ],
      type: 'more',
      url: '',
    },
  ]);
  protected readonly temperature = httpResource<Temperature>(() => ({
    headers: {
      Authorization: 'Basic 6501b52adbac5a809447da4f',
    },
    params: { fields: 'temperature' },
    priority: 'high',
    url: Environment.temperatureUrl,
  }));
}
